import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    height: '80vh',
    width: '90vw',
    justifyContent: 'center',
    alignItems: 'center',
  },
  innerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});
